/**
 * Action creator for patching a patient.
 *
 * Expects a JSON-Patch (RFC 6902) array produced upstream via
 * fast-json-patch `compare()`. Caller owns the diff — this factory
 * does not re-diff. Mirrors the inline action in the legacy
 * `PatientEditModal` so the backend contract is unchanged.
 *
 * Endpoint: PATCH /accounts/:accountUuid/patients/:patientUuid
 */
const editPatientAction = ({ accountUuid, patientUuid, patches }) => ({
  method: 'PATCH',
  endpoint: `/accounts/${accountUuid}/patients/${patientUuid}`,
  body: patches,
});

export default editPatientAction;
